export const zhCN = {
  locale: 'zh-CN',
  nav: {
    setup: '启动中心',
    news: '新闻',
    brand: 'WC26模拟器',
    teamName: '球队名称',
    tactics: '战术',
    fixtures: '赛程',
    standings: '积分榜',
    knockout: '淘汰赛',
    teamStats: '球队数据',
    playerStats: '球员数据',
  },
  landing: {
    title: '世界杯模拟器',
    subtitle: '从揭幕战到决赛夜，选择你的观看席位或教练席位，亲手推进一届 48 队世界杯。',
    audienceMode: {
      title: '观众模拟模式',
      subtitle: '全程观看赛事推进',
      desc: '逐场推进完整赛程，追踪新闻、积分榜、淘汰赛签表、球队数据、射手助攻榜，像赛事数据中心一样旁观整届世界杯。',
    },
    coachMode: {
      title: '教练模拟模式',
      subtitle: '接管一支国家队',
      desc: '选择一支国家队进入教练席，查看阵容和球员数据，赛前调整阵型、心态、压迫、传球与主攻方向，再用 Continue 推进比赛。',
    },
    completed: '已完赛',
    upcoming: '即将进行',
    championRanking: '夺冠模拟排行',
    coachPickRanking: '教练选择排行',
    noCompleted: '暂无已完赛比赛，开始模拟后会显示比分和接近程度。',
    noUpcoming: '',
    noCoachPick: '还没有教练模式选择记录。',
    noChampion: '还没有夺冠模拟记录。',
    coachSetup: {
      title: '选择您想带领的队伍，作为主教练赢取荣誉',
      back: '返回',
      start: '开始我的世界杯之旅',
      processing: '创建旅程中',
      hiddenTeamsOpen: "打开隐藏球队",
      hiddenTeamsClose: "关闭隐藏球队",
    },
    rosterInfo: 'Group {group} · {count} 人名单',
    simKicker: {
      audience: 'Audience Mode · 全景模拟',
      coach: 'Coach Mode · Group {group}',
    },
    simTitle: {
      audience: '世界杯全景模拟中心',
      coach: '{flag} {name} 的世界杯赛程',
    },
    warning: {
      leave: '离开后，当前模拟数据会丢失。',
      confirm: '离开后，当前模拟数据会丢失。确定要离开当前模拟吗？',
    },
    groupLabel: '{id}组',
    championCount: '{count} 次',
    coachPickCount: '{count} 次',
  },
  common: {
    continue: '继续',
    processing: '处理中',
    completed: '已完成',
    close: '关闭',
    back: '返回',
    vs: 'VS',
    restart: '重新开局',
    restartConfirm: '确定要重新开局吗？当前模拟进度和本地保存数据会被清除。',
    requestFailed: '请求失败',
    playAgain: '再来一次',
  },
  team: {
    tab: {
      players: '球员列表',
      fixtures: '赛程',
      tactic: '战术',
    },
    playerTable: {
      player: '球员',
      club: '俱乐部',
      status: '状态',
      position: '位置',
      ability: '能力',
      age: '年龄',
      caps: '国家队',
      ntGoals: '国进',
      apps: '场',
      goals: '进',
      assists: '助',
      rating: '均分',
    },
    status: {
      redCard: '红牌',
    },
    noTactic: '这支球队还没有已完赛比赛，暂无上一场战术。',
    tactic: {
      formation: '阵型',
      mentality: '心态',
      width: '宽度',
      tempo: '比赛节奏',
      passing: '传球偏好',
      attackRoute: '组织打法',
      transition: '组织推进',
      pressing: '逼抢',
      defensiveLine: '防线',
      possession: '控球倾向',
    },
  },
  tactics: {
    formation: '阵型',
    more: '展开更多阵型',
    roster: {
      title: '队员列表',
      order: '序',
      status: '状态',
      name: '姓名',
      position: '位置',
      ability: '能力',
      apps: '场',
      goals: '进',
      assists: '助',
    },
    emptySlot: '空位',
    noData: '暂无战术数据',
    benchPrefix: '替',
    starterPrefix: '首发',
  },
  stats: {
    team: {
      title: '球队数据',
      subtitle: '按球队累计表现排序',
      noData: '暂无球队数据。',
      ranking: '球队排行',
      value: '数值',
      matches: '比赛',
    },
    player: {
      title: '球员数据',
      subtitle: '球员排行',
      noData: '暂无球员数据。',
      nationality: '国籍/地区',
      value: '数值',
      apps: '出场',
    },
    playerTotals: {
      title: '本队球员累计数据',
      subtitle: '仅统计已完成比赛。',
      noData: '本队还未完成比赛。',
    },
    groups: {
      overall: '综合',
      form: '状态',
      discipline: '纪律',
      attack: '进攻',
      creative: '组织',
      goalkeeping: '守门',
    },
    items: {
      avgPossession: '平均控球率',
      goalsFor: '进球',
      xg: '进球机会值',
      shots: '射门',
      formText: '状态',
      winStreak: '连胜场次',
      unbeatenStreak: '连续不败',
      winlessStreak: '连续不胜',
      scorelessStreak: '连续不进球场次',
      yellowCards: '黄牌',
      redCards: '红牌',
      fouls: '犯规',
      goals: '进球',
      assists: '助攻',
      minutesPerGoal: '分钟/进球',
      apps: '出场次数',
      starts: '首发出场',
      averageRating: '平均评分',
      keyPasses: '关键传球',
      passesAttempted: '传球',
      passCompletion: '传球成功率',
      saves: '扑救',
    },
    descriptions: {
      avgPossession: '已完成比赛中的平均控球率',
      goalsFor: '球队累计进球排行',
      xg: '球队累计高质量机会排行',
      shots: '球队累计射门排行',
      formText: '最近比赛状态序列',
      winStreak: '当前连续取胜场次',
      unbeatenStreak: '当前连续不败场次',
      winlessStreak: '当前连续未取胜场次',
      scorelessStreak: '当前连续没有进球的场次',
      yellowCards: '球队累计黄牌排行',
      redCards: '球队累计红牌排行',
      fouls: '球队累计犯规排行',
      playerGoals: '球员累计进球排行',
      playerAssists: '球员累计助攻排行',
      playerXg: '球员累计高质量机会排行',
      playerShots: '球员累计射门排行',
      minutesPerGoal: '每粒进球所需分钟，进球球员优先',
      playerApps: '球员累计出场次数排行',
      playerStarts: '出场时间达到 45 分钟的比赛场次',
      playerYellowCards: '球员累计黄牌排行',
      playerRedCards: '球员累计红牌排行',
      playerAvgRating: '有评分出场的平均评分排行',
      playerKeyPasses: '球员累计关键传球排行',
      playerPasses: '球员累计传球次数排行',
      playerPassCompletion: '累计传球成功率排行',
      playerSaves: '门将累计扑救次数排行',
    },
  },
  position: {
    gk: '门将',
    def: '后卫',
    mid: '中场',
    fwd: '前锋',
  },
  stage: {
    'Group Stage': '小组赛',
    'Round of 32': '三十二强淘汰赛',
    'Round of 16': '十六强淘汰赛',
    'Quarter-final': '四分之一决赛',
    'Semi-final': '半决赛',
    'Third Place': '三四名决赛',
    'Final': '决赛',
  },
  match: {
    penaltyMarker: '点',
    extraTimeMarker: '加',
    penalty: {
      scored: '罚进',
      missed: '罚丢',
    },
    status: {
      finished: '已完赛',
      notStarted: '未开赛',
      pending: '待赛',
    },
    viewDetail: '查看比赛详情',
    modal: {
      teamData: '球队数据',
      playerData: '球员数据',
      finalResult: '最终成绩',
      restart: '再来一次',
      subtitle: {
        extra: '常规时间 {normal}，加时 {extra}。',
        penalty: '常规时间 {normal}，加时 {extra}，点球 {penalty}，{winner} 晋级。',
      },
    },
    shootout: '点球大战',
    extraTime: '加时',
    decision: {
      penalty: ' · 点球 {home}-{away}',
      extra: ' · 加时 {home}-{away}',
    },
    news: {
      penalty: '常规时间双方战成 {normal}，加时赛比分为 {extra}；点球大战中，{winner}以 {penalty} 胜出。',
      extraTime: '常规时间双方战成 {normal}，加时赛又产生 {goals} 粒进球，最终比分定格为 {final}。',
    },
    fallback: '{home} 与 {away} 在 {stage} 交出 {score}。',
    eventsFallback: '比赛由中场控制和防守细节决定。',
    roundLabel: '第{n}轮',
    loading: {
      title: '比赛日模拟中',
      preparing: '准备 {home} vs {away}',
      finished: '完场 {home} {score} {away}',
      noMatches: '本比赛日没有待模拟比赛',
    },
    scorers: {
      home: '',
      away: '',
    },
    xg: 'xG {home}/{away}',
    possession: '控球 {home}/{away}',
    shots: '射门 {home}/{away}',
    best: '最佳 {player}',
    simulate: '模拟',
    simTitle: '模拟结果',
    simProgress: '为你模拟十次本场比赛',
    simulating: '模拟中…',
  },
  fixture: {
    title: '赛程',
    noDate: '暂无比赛日',
    prevDay: '上一个比赛日',
    nextDay: '下一个比赛日',
  },
  knockout: {
    title: '淘汰赛',
    subtitle: '从 32 强到决赛的晋级路线',
    tabs: {
      bracket: '对阵树状图',
    },
    stageNotGenerated: '这一阶段赛程尚未生成。',
    tbd: '待定',
  },
  standings: {
    rank: '排名',
    team: '球队',
    played: '赛',
    wins: '胜',
    draws: '平',
    losses: '负',
    goalsFor: '进',
    goalsAgainst: '失',
    goalDiff: '净',
    points: '分',
    filter: '过滤',
  },
  tacticsControls: {
    mentality: {
      label: '心态',
      options: ['全力进攻', '进攻', '积极进取', '攻守平衡', '小心谨慎', '防守', '全力防守'],
    },
    width: {
      label: '宽度',
      options: ['收缩', '较窄', '居中', '较宽', '拉开'],
    },
    tempo: {
      label: '比赛节奏',
      options: ['慢', '较慢', '正常', '较快', '快'],
    },
    passing: {
      label: '传球偏好',
      options: ['长传', '直传', '混合', '偏向短传', '更多短传'],
    },
    attackRoute: {
      label: '组织打法',
      options: ['边路', '混合', '中路'],
    },
    transition: {
      label: '组织推进',
      options: ['从门将开始组织', '从防线开始组织', '混合', '快速把球到中场开始组织', '快速让球到前场'],
    },
    defensiveLine: {
      label: '防线',
      options: ['低位', '中位', '高位'],
    },
    pressing: {
      label: '逼抢',
      options: ['低位', '中位', '高位'],
    },
    possession: {
      label: '控球倾向',
      options: ['放弃控球', '更少控球', '均衡', '更多控球', '完全控球'],
    },
  },
  formations: {
    '4-2-3-1A': '四后卫，两后腰，两边锋，一前腰，一中锋',
    '4-2-3-1S': '四后卫，两后腰，一中前卫，两边锋，一中锋',
    '4-3-3': '四后卫，三中场，三前锋',
    '4-1-4-1': '四后卫，一后腰，四中场平行站位，一中锋',
    '4-1-2-2-1': '四后卫，一后腰，两中前卫，两边锋，一中锋',
    '4-3-1-2M': '四后卫，三中前卫，一前腰，两前锋',
    '4-3-1-2D': '四后卫，三后腰，一中前卫，两前锋',
    '4-3-2-1M': '四后卫，三中前卫，两前腰，一中锋',
    '4-3-2-1D': '四后卫，三后腰，两中前卫，一中锋',
    '4-3-2-1S': '四后卫，三中前卫，两边锋，一中锋',
    '4-4-1-1': '四后卫，四中场平行站位，一前腰，一中锋',
    '4-2-2-2': '四后卫，两后腰，两边锋，两前锋',
    '4-4-2F': '四后卫，四中场平行站位，两前锋',
    '4-4-2D': '四后卫，四中场菱形中场，两前锋',
    '3-3-2-2': '三中后卫，两边翼卫，一后腰，两中场，两前锋',
    '3-2-4-1': '三中后卫，两后腰，两边前卫，两中前卫',
    '3-2-2-2-1': '三中后卫，两边翼卫，两中场，两边锋，一中锋',
    '3-2-3-2D': '三中后卫，两后腰，两边前卫，一中前卫，两前锋',
    '3-2-3-2W': '三中后卫，两边翼卫，三中场，两前锋',
    '3-4-1-2': '三中后卫，两边翼卫，两后腰，一前腰，两中锋',
    '3-4-2-1S': '三中后卫，两边翼卫，两后腰，两边锋，一中锋',
    '3-4-2-1C': '三中后卫，两边翼卫，两后腰，两前腰，一中锋',
    '3-4-3F': '三中后卫，四中场平行站位，三前锋',
    '3-4-3D': '三中后卫，四中场菱形站位，三前锋',
    '5-3-2': '五后卫，三中前卫，两前锋',
    '5-4-1F': '五后卫，四中场平行站位，一中锋',
    '5-4-1D': '五后卫，四中场菱形站位，一中锋',
    '5-2-2-1': '五后卫，两后腰，两边锋，一前锋',
  },
  news: {
    title: '新闻',
    subtitle: '赛程推进与关键结果',
    titleTexts: {
      groupRecap: '小组赛总结：出线格局、冷门与个人榜单',
      knockoutRecap: '{stage}总结：晋级名单与关键转折',
      stagePreview: '{stage}前瞻：关键对阵与晋级概率',
      championRoad: '{flag} {name} 的夺冠之路',
      awards: '世界杯个人奖项：最佳球员、最佳射手与最佳门将',
      review: '世界杯总回顾：冠军、冷门、大比分与个人英雄',
      coachSummary: '{team} 的征程总结',
    },
    kicker: {
      author: '作者消息',
      guide: '简单说明',
      welcome: {
        coach: '欢迎来到教练席',
        audience: '欢迎来到赛事中心',
      },
      stageRecap: '阶段总结 · {stage}',
      stagePreview: '阶段前瞻 · {stage}',
      champion: '冠军故事',
      awards: '奖项公布',
      tournamentReview: '赛事回顾',
      pregame: '赛前',
      coachSummary: '征程总结',
    },
    default: {
      title: '世界杯模拟尚未开球',
      body: '选择模式后，新闻中心会开始更新。',
    },
    guide: {
      title: '继续 会先带你读新闻，再推进比赛日',
      body: '「继续」按钮在页面右上角。观众模式下，未读新闻会优先展示；新闻读完后会进入当天赛程页；再次点击「继续」才会模拟当天全部比赛。',
    },
    author: {
      title: '来自作者的欢迎',
      body: '感谢你忍受了一个程序员「通宵爆肝」的审美来点击这里。如果模拟让你开心了，请夸夸作者；如果模拟爆冷了……那就是足球的魅力！如果有任何问题反馈，请来 x.com/diysimon 或者小红书（diysimon）联系我。',
    },
    finalThanks: {
      title: '比赛全部结束 — 感谢你的参与！',
      body: '2026 年世界杯已落下帷幕，感谢你体验本次模拟！欢迎关注作者（X @diysimon / 小红书 diysimon）获取最新更新、反馈渠道和后续项目。你可以随时选择重新开始，尝试不同的路线！',
    },
    coachSummary: {
      intro: '{team} 的世界杯征程已落下帷幕，最终排名为 {position}。',
      record: '纵观整届赛事，{team} 取得了 {wins} 胜 {draws} 平 {losses} 负，攻入 {goalsFor} 球，失 {goalsAgainst} 球。',
      position: '{team} 最终排名 {position}。',
      exit: '他们在 {stage} 中被 {opponent} 淘汰。',
      exitNone: '他们在淘汰赛中保持不败。',
      topScorer: '队内最佳射手：{name}（{goals} 球）。',
      noScorer: '队内没有特别突出的射手。',
      bestWin: '最大比分胜利：{match}。',
      meta: '{wins}胜 {draws}平 {losses}负 | 进{goalsFor} 失{goalsAgainst} | {position}',
      factRecord: '战绩：{wins}胜 {draws}平 {losses}负',
      factGoals: '进球：{goalsFor} / 失球：{goalsAgainst}（净胜{diff}）',
      factTopScorer: '最佳射手：{name}（{goals} 球）',
      factChampion: '{team} 夺得世界杯冠军！',
      factFinish: '最终排名：{position}',
      positions: {
        champion: '冠军',
        runnerUp: '亚军',
        semiFinal: '四强',
        quarterFinal: '八强',
        round16: '十六强',
        round32: '三十二强',
        groupStage: '小组赛',
      },
    },
    welcome: {
      coach: {
        title: '{flag} {name} 开启世界杯模拟旅程',
        body: '你已经接管 {name}。左侧菜单可以查看球队、战术、赛程、积分榜和数据榜；右上角 Continue 会推进到下一步。',
      },
      audience: {
        title: '2026 世界杯全景模拟已经载入',
        body: '你正在以观众视角观看整届赛事。系统会逐场推进比赛，并持续更新新闻、赛程、积分榜、淘汰赛和数据榜。',
      },
    },
    facts: {
      thanks: '感谢试玩',
      feedback: '欢迎继续反馈',
      entertainment: '模拟结果仅供娱乐',
      newsFirst: '新闻按新内容优先展示',
      fixtureBrowse: '赛程页按比赛日浏览',
      resultsGenerate: '比赛结果会继续生成新闻',
      newsUpdates: '新闻会随比赛推进更新',
      timeline: '顶部时间格展示接下来赛程',
      refreshWarning: '刷新或离开会丢失当前模拟',
      operation: '操作说明',
      preMatch: '赛前简报',
    },
    narrative: {
      intro: {
        penalty: '{winner}在点球大战中以 {score} 胜出，经过{stage}的拉锯后继续前进。',
        extraTime: '{winner}在加时赛后以 {winnerScore} 击败对手，赢下这场{stage}硬仗。',
        win: [
          '{winner}在{stage}把比赛带进自己的节奏，最终以{score}击败对手。',
          '{stage}一战，{winner}用更稳定的攻防效率拿下{score}。',
          '{winner}在这场{stage}较量中把握住关键回合，比分定格在{score}。',
          '{winner}没有浪费机会，在{stage}以{score}收下胜利。',
          '这场{stage}从开局就充满拉扯，{winner}最终凭借关键进球赢下{score}。',
        ],
        draw: [
          '{stage}出现一场胶着平局，{home}与{away}最终战成{score}。',
          '{home}和{away}在{stage}互有攻守，常规时间后比分停在{score}。',
          '这场{stage}没有分出胜负，{home}与{away}以{score}结束比赛。',
        ],
      },
      noEvent: [
        '双方都没有制造决定性破门，比赛更多由中场对抗和禁区前沿的封堵决定。',
        '两队的防线都保持了足够密度，真正能够改变比分的机会并不多。',
        '门前效率成为比赛的主线，几次推进都被最后一脚处理拖慢。',
      ],
      goal: {
        extraTime: [
          '{minute}，加时赛进入关键阶段，{scorer}接应{assister}的传球后{method}破门，比分变为{score}。',
          '{minute}，{team}在加时赛中把握住机会，{scorer}{method}得手，{team}{state}。',
          '{minute}，体能下降后防线出现空当，{scorer}冷静{method}，这粒加时进球把比分改写为{score}。',
          '{minute}，{scorer}在加时赛中完成决定性一击，{method}让{team}重新掌握主动。',
        ],
        withAssist: [
          '{minute}，{scorer}接到{assister}从右路送出的传中，抢在后卫身前以{method}完成破门，{team}{state}，比分变为{score}。',
          '{minute}，{assister}在肋部送出关键传球，{scorer}顺势前插后{method}得手，{team}{state}。',
          '{minute}，{team}打出连续配合，{assister}把球做给{scorer}，后者冷静{method}，场上比分来到{score}。',
          '{minute}，{scorer}利用{assister}的传中完成致命一击，{method}让门将无从反应，{team}{state}。',
          '{minute}，{assister}送出穿透防线的一脚球，{scorer}在禁区内{method}，把比分改写为{score}。',
          '{minute}，{team}在前场完成抢断后迅速推进，{assister}横传找到{scorer}，{scorer}{method}命中。',
          '{minute}，{assister}把定位球开到危险区域，{scorer}在人群中完成{method}，{team}{state}。',
          '{minute}，{scorer}接应{assister}的倒三角传球，第一时间{method}，这次进攻让比分来到{score}。',
          '{minute}，{assister}吸引防守后分球，{scorer}获得空间并{method}，{team}{state}。',
          '{minute}，{team}耐心转移终于撕开缺口，{assister}送出最后一传，{scorer}{method}破门。',
        ],
        solo: [
          '{minute}，{scorer}在禁区前沿摆脱防守后{method}，{team}{state}，比分来到{score}。',
          '{minute}，{scorer}抓住对方解围不远的机会，迎球{method}破门。',
          '{minute}，{scorer}从中场推进到弧顶，随后以一脚{method}把球送入网窝。',
          '{minute}，{team}通过高压制造混乱，{scorer}机敏补射得手，比分变为{score}。',
          '{minute}，{scorer}在混战中最先完成反应，近距离{method}，{team}{state}。',
        ],
        methodHigh: ['头球', '推射', '近距离垫射', '门前包抄'],
        methodLow: ['远射', '弧线球兜射', '禁区外低射', '凌空抽射'],
        methodMid: ['抽射', '低射', '劲射', '冷静推射', '小角度打门'],
      },
      chance: [
        '{minute}，{team}差点{chanceState}，{player}获得单刀机会但被门将化解。',
        '{minute}，{player}在禁区内得到黄金机会，可惜最后一下打偏。',
        '{minute}，{team}通过快速反击制造险情，{player}的射门与进球擦肩而过。',
        '{minute}，{player}接应传中完成抢点，但这次攻门没能改变比分。',
      ],
      redCard: [
        '{minute}，{team}遭遇打击，{player}被红牌罚下，比赛走势随之变得紧张。',
        '{minute}，{player}吃到红牌离场，{team}不得不在剩余时间里收缩阵型。',
        '{minute}，裁判向{player}出示红牌，{team}的比赛计划被迫改变。',
      ],
      flow: {
        xgGap: '{dominant}制造了更多高质量机会，机会质量对比为 {xgHome}-{xgAway}，射门数则是 {shotsHome}-{shotsAway}。',
        possession: '{controller}掌握了更多球权，控球率达到 {possession}%，但比赛仍取决于禁区内效率。',
        balanced: '从数据看，双方高质量机会差距并不夸张，机会质量为 {xgHome}-{xgAway}，比赛细节主要集中在转换和最后一脚。',
      },
      tactic: {
        control: [
          '战术层面，{controller}更像是主动控场的一方，他们用连续传递把比赛节奏压在自己脚下，控球率达到 {possession}%。',
          '{controller}的比赛计划很清晰：先稳住球权，再寻找边路或肋部的推进机会，这让{away}很难连续组织反击。',
          '从场面看，{controller}通过更长时间的控球削弱了对手的压迫强度，比赛大部分时间都按他们设定的节奏运行。',
          '{controller}把阵线保持得更紧凑，传球推进耐心充足，控球优势也转化成了更稳定的前场停留时间。',
        ],
        direct: [
          '{direct}没有过分追求控球，而是把重点放在快速到达禁区，更多射门说明他们的进攻选择更直接。',
          '进攻方式上，{creator}更善于把球送进危险区域，关键传球数量的优势让他们持续给对方防线施压。',
          '{direct}的推进更讲效率，几次纵向传递都绕开了中场缠斗，直接把比赛带到门前。',
          '{creator}在前场的线路选择更丰富，边路传中、肋部直塞和二点球争夺都形成了实际威胁。',
        ],
        pressure: [
          '{presser}在无球阶段投入很大，抢断和拦截让对手很难舒服地完成第一脚出球。',
          '{presser}的防守纪律值得一提，中前场回收速度很快，多次把危险化解在禁区前。',
          '这场比赛的身体对抗强度不低，{presser}靠更积极的逼抢切断了不少推进线路。',
          '{presser}在丢球后的反抢很果断，虽然不一定每次都形成射门，但有效压缩了对手的反击空间。',
        ],
        balanced: [
          '两队在战术执行上都偏谨慎，阵型间距保持得比较紧，比赛因此更多落在局部对抗和第二落点争夺上。',
          '这不是一场完全开放的比赛，双方都没有长时间放弃防守结构，进攻端主要依赖几次关键传球打开局面。',
          '整体来看，两队都在控制风险，前场投入相对克制，真正改变局面的还是少数高质量处理。',
          '战术层面双方互有克制，一方试图提速，另一方则用更密集的中路站位限制推进空间。',
          '比赛节奏几次被中场争夺打断，说明两队都把防守转换看得很重，没有轻易给对手留下大片空间。',
        ],
      },
      coach: {
        late: [
          '教练组的耐心收到了回报，{winner}在后半段没有急于冒进，而是等到对手体能下降后完成致命一击。',
          '{winner}替补席和场上执行保持同步，比赛尾段还能持续压上，说明教练组对节奏的把握比较准确。',
          '从临场管理看，{winner}没有在僵局中失去秩序，后段进球更像是持续施压后的自然结果。',
          '{winner}教练组在最后阶段选择继续向前压迫，这个决定让球队拿到了决定比赛的回合。',
        ],
        red: [
          '红牌出现后，{redTeam}教练组被迫调整站位，球队更多依靠收缩防线和快速出球维持比赛平衡。',
          '{opponent}在人数优势下尝试拉开宽度，不过{redTeam}的临场收缩让比赛没有立刻失控。',
          '少打一人的局面考验了{redTeam}的临场应变，他们减少了中路冒险传球，优先保证禁区前人数。',
          '{opponent}教练组在红牌后明显要求球队加快转移，试图把人数优势转化成边路空间。',
        ],
        narrow: [
          '{winner}教练组的取舍很务实，领先后没有盲目扩大阵型，而是用更稳的站位保护优势。',
          '临场选择上，{winner}更重视比赛控制，进球之后球队明显降低了无谓冒险。',
          '{winner}赢得并不铺张，但教练组对风险的管理很到位，最后阶段没有给{loser}太多反扑空间。',
          '这场胜利体现了{winner}教练组的现实思路：先保证防守质量，再等待前场球员解决问题。',
        ],
        win: [
          '{winner}教练组赛前布置执行得比较完整，球队在领先后仍能保持推进层次，没有让比赛变成单纯防守。',
          '从临场效果看，{winner}在攻守转换中的站位更合理，教练组显然要求队员第一时间压缩对手出球路线。',
          '{winner}的胜利不只来自个人能力，整体站位和二次进攻保护同样支撑了比分优势。',
          '教练层面，{winner}对比赛节奏的掌控更成熟，球队知道什么时候提速，也知道什么时候把球留在脚下。',
        ],
        draw: [
          '两边教练组都没有在平局中彻底冒险，最后阶段的换人和站位更偏向保证不输。',
          '从临场调整看，双方都试图用边路宽度制造变化，但中路防线始终没有被连续打穿。',
          '这场平局反映出两队教练组的谨慎：进攻端有尝试，防守端却都不愿把阵型完全压出去。',
          '比赛后段双方都加强了中场保护，教练组显然更担心被对手一次反击带走比赛。',
        ],
      },
      player: {
        goals: [
          '个人表现方面，{player}是最醒目的名字，他用多次终结改变比赛，赛后评分达到 {rating}。',
          '{player}的门前感觉决定了比赛走向，几次跑位都踩在防线身后最难处理的位置。',
          '{team}的进攻最终由{player}完成兑现，他的射门选择冷静，也给对手防线持续制造压力。',
          '如果只看决定性，{player}就是本场关键先生，他把球队制造出的机会转化成了真正的比分优势。',
        ],
        attack: [
          '{player}在关键回合里存在感很强，进球或助攻之外，他的接应也让{team}的前场运转更顺。',
          '{player}的贡献不只体现在数据上，他多次出现在进攻最需要支点的位置。',
          '本场{player}把握住了属于自己的窗口期，关键处理让{team}的进攻有了落点。',
          '{player}在前场的选择很果断，该传时传、该射时射，是{team}最稳定的进攻出口之一。',
          '{player}的跑动拉开了不少空间，他的直接参与也让比赛走势发生变化。',
        ],
        saves: [
          '{player}在门前的表现非常重要，多次扑救让{team}保住了比赛悬念。',
          '门将{player}的稳定发挥值得单独提到，他用连续扑救抵消了对手的几次威胁。',
          '{team}能够撑住压力，{player}的门线反应是关键原因之一。',
          '{player}没有太多犯错空间，但他的处理足够稳，尤其是面对近距离攻门时保持了冷静。',
        ],
        create: [
          '{player}是{team}前场最重要的连接点，多次关键传球让队友获得直接面对球门的机会。',
          '{player}的传球视野撑起了{team}的进攻层次，他经常能在拥挤区域找到出球线路。',
          '{team}需要有人把球送到危险地带，{player}正好承担了这个角色。',
          '{player}没有一味追求个人终结，而是用传球把队友带进更好的射门位置。',
        ],
        defense: [
          '{player}在防守端覆盖面积很大，抢断和拦截帮助{team}稳住了中场屏障。',
          '{team}能够限制对手推进，{player}的回追和预判起到了明显作用。',
          '{player}的价值体现在无球阶段，他多次提前破坏对手传球线路。',
          '防守评价里，{player}值得被点名，他让{team}在禁区前沿少承受了很多直接冲击。',
        ],
        shots: [
          '{player}虽然没有完全把机会转化为进球，但他的持续射门让对手防线始终不敢放松。',
          '{team}的进攻火力有很大一部分来自{player}，他不断用射门尝试打开局面。',
          '{player}的积极性很高，多次完成射门说明他在前场找到了空间。',
          '{player}离进球并不远，他的几次处理已经迫使对方门将保持高度集中。',
        ],
        general: [
          '{player}拿到全场较高评分，他的稳定处理让{team}在攻守两端都少了很多波动。',
          '{player}的数据不一定最抢眼，但比赛参与度很高，是{team}保持运转的重要一环。',
          '从评分看，{player}的综合表现最被认可，他在多个回合里都做出了正确选择。',
          '{player}这场比赛的价值在于稳定，他很少浪费球权，也能及时参与防守回合。',
        ],
      },
      impact: {
        finalWin: '{winner}赢下决赛，正式捧起本届世界杯冠军奖杯，{loser}的旅程停在最后一步。',
        thirdPlace: '{winner}获得本届世界杯第三名，{loser}排名第四。',
        semiFinal: '{winner}凭借这场胜利进军决赛，{loser}则无缘冠军争夺。',
        quarterFinal: '{winner}闯入四强，距离决赛只差一场胜利。',
        knockoutWin: '{winner}通过这场淘汰赛继续前进，{loser}被挡在下一轮门外。',
        placementBothDark: '两队都明显高于赛前赔率预期，三四名决赛本身已经是黑马故事的延伸。',
        placementThirdDark: '{thirdName}以赛前赔率前 20 之外的身份站上领奖台，表现明显高于预期。',
        placementFourthDark: '{fourthName}虽然输掉这场比赛，但能进入四强已经明显高于赛前预期。',
        placementBothFavored: '两队都属于赛前赔率前 20 的强队，最终进入四强基本兑现了纸面竞争力。',
        groupLead: '{teamName}小组赛 {played} 战积 {points} 分，排名小组第 {rank}，已经拿到晋级淘汰赛的主动权。',
        groupEliminated: '{teamName}小组赛 {played} 战只有 {points} 分，排名小组第 {rank}，已经无法晋级下一阶段。',
        groupUpdate: '本场过后，{teamName}积 {points} 分，暂列 {group} 组第 {rank}。',
        groupQualifiers: '{groupId}组：{names}',
        qualified: '过关',
        eliminated: '出局',
        favoriteStatus: '{name}{status}',
        darkHorses: '{names}是这一阶段最值得注意的黑马，他们在积分、净胜球或关键战中打出了超出纸面实力的表现。',
        noDarkHorses: '整体来看，热门球队大多守住了基本盘，小组排名没有出现大面积失控。',
        unbeaten: '{names}保持不败，稳定性尤其突出。',
        scorers: '个人表现方面，{scorerLine}，{assisterLine}。{ratingLine}',
        scorerLead: '{name}以 {goals} 球领跑射手榜',
        scorerDisperse: '射手榜竞争仍很分散',
        assisterLead: '{name}送出 {assists} 次助攻',
        assisterDisperse: '助攻榜尚未拉开差距',
        ratingHighlight: '{name}的平均评分达到 {rating}，是小组赛最耀眼的球员之一。',
      },
      recap: {
        groupIntro: [
          '小组赛全部结束，32 支出线球队已经确定，世界杯正式进入淘汰赛节奏。',
          '72 场小组赛落下帷幕，晋级名单、冷门故事和个人数据榜都已经有了清晰轮廓。',
          '小组赛阶段完成全部赛程，强队的稳定性、黑马的爆发和射手榜竞争成为这一阶段的主线。',
        ],
        knockoutIntro: '{stage}全部结束，{count} 支球队继续留在冠军路线中。',
        knockoutWinners: '{names}拿到下一轮门票。',
        knockoutTight: '其中 {count} 场比赛只差一球或进入点球决胜，淘汰赛强度明显提高。',
        knockoutClear: '这一轮的胜负分界相对清晰，晋级球队整体掌控力更强。',
        knockoutBiggest: '本轮最开放的比赛是 {match}，双方合计打进 {goals} 球。',
        knockoutUpset: '冷门来自 {winner} 淘汰 {loser}，纸面实力较低的一方打出了更高效的比赛。',
        knockoutScorers: '个人层面，{scorerLine}；{ratingLine}',
        knockoutScorerLead: '{name}继续以 {goals} 球领跑射手榜',
        knockoutScorerDisperse: '射手榜仍未形成绝对领先',
        knockoutRating: '{name}维持高评分，是淘汰赛阶段最稳定的核心之一。',
        knockoutRatingGeneric: '多名核心球员的表现开始影响冠军走势。',
        groupLines: '各组出线情况如下：{lines}。{favorites}',
        groupFavorites: '热门球队方面，{status}。',
        groupQualifierFormat: '{groupId}组：{names}',
        groupMeta: '{count}队晋级 · {scorerInfo}',
        scorerInfo: '射手榜 {name}',
        scorerInfoUpdate: '数据榜更新',
        factQualified: '出线 {count}队',
        factDarkHorses: '黑马 {names}',
        factStable: '热门整体稳定',
        factTopScorer: '射手榜 {name} {goals}球',
        factTopAssister: '助攻榜 {name} {assists}助',
        knockoutMeta: '{count}队晋级 · {tight}场胶着战',
        factKnockoutTight: '胶着战 {count}场',
        factKnockoutClear: '胜负较清晰',
        factUpset: '冷门 {winner}',
        factOpen: '最开放 {goals}球',
      },
      preview: {
        intro: '{stage}对阵已经成型，下一阶段将通过 {count} 场比赛筛出 {count} 支球队。',
        keyMatch: '值得关注的对决包括：{matches}。',
        noKeyMatch: '这一阶段暂时没有赛前赔率前 20 球队之间的直接交锋，强队更需要避免在看似有优势的对阵中失误。',
        favorites: '从纸面实力和本届表现综合看，{names}更被看好进入下一阶段。',
        noFavorites: '这一轮整体差距不大，临场状态和进球效率可能比排名更重要。',
        tail: [
          '进入淘汰赛后，领先后的控场、定位球防守和门将状态会被放大，任何一次失误都可能改变整条晋级路线。',
          '这一阶段的关键不只是进攻火力，教练组的换人时机、风险管理和点球准备都会影响最终走向。',
          '强队需要避免慢热，黑马则要继续把比赛拖入自己熟悉的节奏，前 30 分钟的对抗强度会非常关键。',
        ],
        previewMeta: '{count}场对决',
        factMatchup: '对阵 {count}场',
        factFocus: '焦点 {matchup}',
        factFavorite: '看好 {name}',
      },
      champion: {
        road: '{champion}的冠军之路已经完整写下：从小组赛到决赛，他们一共完成 {count} 场比赛，战绩为 {wins} 胜 {draws} 平，打进 {goalsFor} 球、丢 {goalsAgainst} 球。',
        groupPath: '小组赛阶段，{champion}先把出线主动权握在手中，{matches}。',
        knockoutPath: '进入淘汰赛后{opponents}。',
        signatureMatch: '其中 {match} 是最能代表冠军气质的一场。',
        tail: [
          '这支冠军队的共同特点是稳定：领先时能控制比赛，落后或胶着时也能找到新的进攻出口。',
          '他们的夺冠不只是靠某一个爆点，而是靠防线稳定、核心球员持续输出和教练组临场管理共同支撑。',
          '从整届走势看，冠军最难得的地方在于没有被单场波动击穿，淘汰赛每一轮都能把关键回合处理好。',
        ],
        meta: '{wins}胜{draws} · {goalsFor}-{goalsAgainst}',
        drawsText: '{draws}平',
        fact: '冠军 {champion}',
        factGoal: '进球 {goalsFor}',
        factConcede: '失球 {goalsAgainst}',
        factSignature: '代表作 {match}',
      },
      awards: {
        intro: '随着决赛结束，本届世界杯的个人奖项也正式出炉。{bestPlayer}',
        bestPlayer: '{name}凭借稳定评分和关键场次表现，当选最佳球员。',
        noBestPlayer: '最佳球员竞争非常接近，多个核心都打出了高水平表现。',
        topScorer: '最佳射手属于 {name}，他一共打进 {goals} 球，是本届赛事最稳定的终结点。',
        noTopScorer: '射手榜没有出现明显断层，但前场球员的效率仍决定了很多比赛。',
        topAssister: '助攻榜方面，{name}以 {assists} 次助攻领跑，他的传球直接改变了多场比赛的走势。',
        bestKeeper: '最佳门将给到 {name}，他完成 {saves} 次扑救，场均失球控制在 {conceded}。',
        noBestKeeper: '门将奖项竞争集中在几名淘汰赛表现稳定的球员之间。',
        scorerFallback: '射手榜领跑者',
        keeperFallback: '最佳门将候选',
        summary: '{names}构成了本届赛事最有代表性的个人叙事：有人负责推进，有人负责终结，也有人守住底线。',
        noSummary: '本届世界杯的个人表现呈现出明显的团队属性，奖项背后离不开战术体系的支撑。',
      },
      review: {
        intro: '本届世界杯全部结束，{total} 场比赛一共打进 {goals} 球，场均 {average} 球。',
        scoring: '{highScoring} 场比赛至少出现 4 个进球，{btts} 场比赛双方都有进球。{biggest}',
        biggest: '最开放的一场是 {match}。',
        upsetSep: '淘汰/击败',
        assisterFallback: '多名组织者',
        ratingFallback: '核心球员',
        upsets: '冷门记忆包括 {upsets}。',
        noUpsets: '整体走势中，强队大多兑现了纸面优势，但淘汰赛仍然多次被细节左右。',
        champion: '最终，{champion}把稳定性保持到最后，成为整届赛事的主角。',
        leaders: '个人榜单方面，{scorer}的进球效率、{creators}的创造力，以及{ratings}的持续高评分，共同构成了本届世界杯的数据记忆。',
        noLeaders: '从整体观感看，这届赛事既有强队掌控，也有黑马冲击，比赛内容比单纯比分更丰富。',
        awardsMeta: '最佳球员 {name}',
        awardsMetaDefault: '奖项盘点',
        factBestPlayer: '最佳球员 {name}',
        factTopScorer: '最佳射手 {name} {goals}球',
        factBestKeeper: '最佳门将 {name}',
        factTopAssister: '助攻王 {name} {assists}助',
        reviewMeta: '{count}场 · {goals}球',
        factTotalGoals: '总进球 {goals}',
        factAvgGoals: '场均 {average}',
        factHighScoring: '4+进球 {count}场',
        factBothScored: '双方进球 {count}场',
      },
    },
  },
  helpers: {
    formText: {
      W: '胜',
      D: '平',
      L: '负',
    },
    goalState: {
      equalize: '扳平比分',
      lead: '取得领先',
      extend: '扩大优势',
      chase: '追回一球',
    },
    chanceState: {
      extend: '扩大优势',
      break: '打破僵局',
      face: '扳回一点面子',
      close: '缩小差距',
    },
    tacticSummary: '心态 {mentality} · 组织 {focus} · 逼抢 {pressing} · 防线 {line}',
    teamMate: '队友',
    attacker: '进攻球员',
    defender: '防守球员',
    advance: '晋级',
    groupLeader: '{group}组榜首 {teamName} {points}分',
    minuteLabel: '分钟',
    unknownPlayer: '未知球员',
    unsolved: '暂无',
    minute: '{minute}\'{stoppage}',
    stoppageTime: '+{minute}',
  },
  rendering: {
    playerTotals: {
      headers: ['球员', '位', '场', '分钟', '进', '助', '进球\n机会', '射', '正', '传', '成', '关键', '抢', '断', '黄', '红', '扑', '均分'],
    },
    matchStats: {
      possession: '控球率',
      shotsOnTarget: '射正',
      passes: '传球',
      passSuccess: '传球成功率',
      keyPasses: '关键传球',
      corners: '角球',
      offsides: '越位',
      fouls: '犯规',
      yellowCards: '黄牌',
      redCards: '红牌',
      saves: '扑救',
      tackles: '抢断',
      interceptions: '拦截',
    },
    modal: {
      best: '最佳',
      record: '战绩',
      stage: '阶段',
      bestPlayer: '最佳球员',
      signature: '名场面',
      playerStatsHeaders: ['球员', '位置', '时间', '评分', '进球', '助攻', '进球<br>机会', '射门', '射正', '传球', '成功', '传球<br>成功率', '关键<br>传球', '抢断', '拦截', '黄牌', '红牌', '扑救'],
    },
    bracket: {
      pending: '待定',
    },
  },
  mobile: {
    help: {
      title: '帮助',
      intro: '这是 2026 世界杯模拟器，从揭幕战到决赛夜，轻点继续即可观看整届模拟进程。',
      howToPlay: '点击「继续」按钮推进比赛，阅读新闻了解赛事进展，赛程、积分榜、淘汰赛和数据榜随时可查看。',
      pcMore: '使用 PC 访问还有教练模式，可以接管一支国家队、调整战术、编辑首发阵容，体验更完整。',
      follow: '欢迎关注',
    },
    landing: {
      intro: '2026 世界杯模拟器',
      description: '从揭幕战到决赛夜，轻点继续即可观看整届 2026 世界杯模拟进程。',
      welcome: '欢迎来到属于你自己的世界杯时间，通过点击快速观赏预测谁会捧起大力神杯。使用PC 访问还支持教练模式。',
      hiddenStart: '带领隐藏球队一起模拟',
      start: '开始模拟',
      startTitle: '立即开始模拟',
      startSubtitle: '真实球队，真实分组，十分钟内，带你以观众视角完全模拟观赏所有比赛',
      hiddenCheckbox: '让意大利、波兰、印尼、中国、阿联酋队参加世界杯',
    },
    topbar: {
      settings: '设置',
    },
    tabs: {
      navigation: '移动端主导航',
      news: '新闻',
      fixtures: '赛程',
      standings: '积分榜',
      knockout: '淘汰赛',
      data: '数据',
    },
    action: {
      continue: '继续',
      readNews: '阅读新闻',
      simulateNext: '模拟下一比赛日',
      restart: '重新开始',
      completed: '赛事已完成',
    },
    settings: {
      title: '设置',
      language: '语言',
      restart: '重新开始',
      restartConfirm: '确定要重新开始吗？当前移动端模拟进度会被清除。',
      close: '关闭设置',
    },
    news: {
      previous: '上一条',
      next: '下一条',
      pcMore: '使用 PC 体验有更多惊喜和功能！',
      empty: '暂无新闻。',
    },
    fixtures: {
      previousDay: '上一比赛日',
      nextDay: '下一比赛日',
      noMatches: '这个比赛日暂无赛程。',
    },
    standings: {
      groupStandings: '小组积分榜',
      knockout: '淘汰赛',
      roundOf32: '32 强',
      roundOf16: '16 强',
      quarterFinal: '四分之一决赛',
      semiFinal: '半决赛',
      thirdPlace: '三四名决赛',
      final: '决赛',
    },
    data: {
      goals: '射手榜',
      assists: '助攻榜',
      pcMore: '使用 PC 体验可以查看更多球员与球队数据。',
      empty: '暂无数据。',
    },
    team: {
      squad: '球队列表',
      fixtures: '赛程',
      tactic: '战术',
      close: '关闭球队浮层',
    },
  },
    teamNames: {

    mexico: '墨西哥',
    south_africa: '南非',
    south_korea: '韩国',
    czechia: '捷克',
    canada: '加拿大',
    bosnia_herzegovina: '波黑',
    switzerland: '瑞士',
    qatar: '卡塔尔',
    brazil: '巴西',
    morocco: '摩洛哥',
    scotland: '苏格兰',
    haiti: '海地',
    united_states: '美国',
    australia: '澳大利亚',
    paraguay: '巴拉圭',
    turkiye: '土耳其',
    germany: '德国',
    curacao: '库拉索',
    ivory_coast: '科特迪瓦',
    ecuador: '厄瓜多尔',
    netherlands: '荷兰',
    japan: '日本',
    tunisia: '突尼斯',
    sweden: '瑞典',
    belgium: '比利时',
    iran: '伊朗',
    egypt: '埃及',
    new_zealand: '新西兰',
    spain: '西班牙',
    uruguay: '乌拉圭',
    saudi_arabia: '沙特阿拉伯',
    cape_verde: '佛得角',
    france: '法国',
    senegal: '塞内加尔',
    norway: '挪威',
    iraq: '伊拉克',
    argentina: '阿根廷',
    austria: '奥地利',
    algeria: '阿尔及利亚',
    jordan: '约旦',
    portugal: '葡萄牙',
    colombia: '哥伦比亚',
    uzbekistan: '乌兹别克斯坦',
    dr_congo: '刚果民主共和国',
    england: '英格兰',
    croatia: '克罗地亚',
    panama: '巴拿马',
    ghana: '加纳',
    italy: '意大利',
    tbd: '待定',
    china: '中国',

    indonesia: "印度尼西亚",
    united_arab_emirates: "阿联酋",
    poland: "波兰",

  },
};
